import BaseApiService from './BaseApiService.js';

class ReportCardService extends BaseApiService {
  async generateReportCard(data) {
    return this.makeRequest('/api/report-cards/generate', {
      method: 'POST',
      body: JSON.stringify(data)
    });
  }

  async updateRemarks(id, classTeacherRemarks, principalRemarks) {
    return this.makeRequest(`/api/report-cards/${id}/remarks`, {
      method: 'PUT',
      body: JSON.stringify({ classTeacherRemarks, principalRemarks })
    });
  }

  async updateStatus(id, status) {
    return this.makeRequest(`/api/report-cards/${id}/status`, {
      method: 'PUT',
      body: JSON.stringify({ status })
    });
  }

  async deleteReportCard(id) {
    return this.makeRequest(`/api/report-cards/${id}`, {
      method: 'DELETE'
    });
  }

  async updateTemplate(id, templateKey) {
    return this.makeRequest(`/api/report-cards/${id}/template`, {
      method: 'PUT',
      body: JSON.stringify({ templateKey })
    });
  }

  async batchUpdateTemplate(data) {
    return this.makeRequest('/api/report-cards/batch/update-template', {
      method: 'PUT',
      body: JSON.stringify(data)
    });
  }

  async getReportCardById(id) {
    return this.makeRequest(`/api/report-cards/${id}`);
  }

  async listByOrg(params = {}) {
    const query = new URLSearchParams(params).toString();
    const endpoint = query ? `/api/report-cards/org?${query}` : '/api/report-cards/org';
    return this.makeRequest(endpoint);
  }

  async listByStudent(studentId) {
    return this.makeRequest(`/api/report-cards/student/${studentId}`);
  }

  async getGradingSchemes() {
    return this.makeRequest('/api/report-cards/grading-schemes');
  }

  async saveGradingSchemes(schemes) {
    return this.makeRequest('/api/report-cards/grading-schemes', {
      method: 'POST',
      body: JSON.stringify(schemes)
    });
  }

  // ==================== EXAMS & MARKS API ====================
  async getTests(params = {}) {
    const query = new URLSearchParams(params).toString();
    const endpoint = query ? `/api/teacher/tests?${query}` : '/api/teacher/tests';
    return this.makeRequest(endpoint);
  }

  async createTest(testData) {
    return this.makeRequest('/api/teacher/tests', {
      method: 'POST',
      body: JSON.stringify(testData)
    });
  }

  async deleteTest(testId) {
    return this.makeRequest(`/api/teacher/tests/${testId}`, {
      method: 'DELETE'
    });
  }

  async updateTest(testId, testData) {
    return this.makeRequest(`/api/teacher/tests/${testId}`, {
      method: 'PUT',
      body: JSON.stringify(testData)
    });
  }

  async getTestResults(testId) {
    return this.makeRequest(`/api/teacher/tests/${testId}/results`);
  }

  async uploadTestResults(testId, resultsData) {
    return this.makeRequest(`/api/teacher/tests/${testId}/results`, {
      method: 'POST',
      body: JSON.stringify(resultsData)
    });
  }

  async lockTest(testId, isLocked) {
    return this.makeRequest(`/api/teacher/tests/${testId}/lock`, {
      method: 'PUT',
      body: JSON.stringify({ isLocked })
    });
  }

  // ==================== EXAM TYPE CONFIG ====================
  // orgId is NOT sent — backend derives it from the JWT token.

  async getExamTypeConfig(academicYear) {
    return this.makeRequest(`/api/report-cards/exam-type-config?academicYear=${encodeURIComponent(academicYear)}`);
  }

  async saveExamTypeConfig(academicYear, examTypes) {
    return this.makeRequest('/api/report-cards/exam-type-config', {
      method: 'POST',
      body: JSON.stringify({ academicYear, examTypes })
    });
  }

  async deleteExamTypeEntry(id) {
    return this.makeRequest(`/api/report-cards/exam-type-config/${id}`, {
      method: 'DELETE'
    });
  }
}

const reportCardServiceInstance = new ReportCardService();
export default reportCardServiceInstance;
